import { generatePath, type Location, type Routes } from '@faceup/router'
import { buildPath } from '@faceup/utils'

export const routes: Record<keyof RoutesInterface, string> = {
  home: '/',
  login: '/',
  createAdmin: '/create-admin',
  schools: '/schools',
  companies: '/companies',
  institution: '/institution/:id',
  reports: '/reports',
  report: '/report/:id',
  partners: '/partners',
  partner: '/partner/:id',
  materials: '/materials',
  globalTables: '/global-tables',
  integrationHttpLogs: '/integration-http-logs',
  hotlines: '/hotlines',
  vonageHotlines: '/vonage-hotlines',
  sendEmails: '/send-emails',
  aiHotlineSystemInstructions: '/ai-hotline-system-instructions',
}

export const useRoutes = (): Routes => ({
  home: () => generatePath(routes.home),
  login: params =>
    buildPath(
      generatePath(routes.login),
      params?.fallback
        ? {
            fallback: `${params.fallback.pathname}${params.fallback.search}${params.fallback.hash}`,
          }
        : {}
    ),
  createAdmin: () => generatePath(routes.createAdmin),
  schools: () => generatePath(routes.schools),
  companies: () => generatePath(routes.companies),
  institution: ({ id }) => generatePath(routes.institution, { id }),
  reports: () => generatePath(routes.reports),
  report: ({ id }) => generatePath(routes.report, { id }),
  partners: () => generatePath(routes.partners),
  partner: ({ id }) => generatePath(routes.partner, { id }),
  materials: () => generatePath(routes.materials),
  globalTables: () => generatePath(routes.globalTables),
  integrationHttpLogs: () => generatePath(routes.integrationHttpLogs),
  hotlines: () => generatePath(routes.hotlines),
  vonageHotlines: () => generatePath(routes.vonageHotlines),
  sendEmails: () => generatePath(routes.sendEmails),
  aiHotlineSystemInstructions: () => generatePath(routes.aiHotlineSystemInstructions),
})

interface RoutesInterface {
  home: RouteNoParams
  login: RouteWithOptionalParams<{ fallback?: Location }>
  createAdmin: RouteNoParams
  schools: RouteNoParams
  companies: RouteNoParams
  institution: RouteWithParams<{ id: string }>
  reports: RouteNoParams
  report: RouteWithParams<{ id: string }>
  partners: RouteNoParams
  partner: RouteWithParams<{ id: string }>
  materials: RouteNoParams
  globalTables: RouteNoParams
  integrationHttpLogs: RouteNoParams
  hotlines: RouteNoParams
  vonageHotlines: RouteNoParams
  sendEmails: RouteNoParams
  aiHotlineSystemInstructions: RouteNoParams
}

type RouteNoParams = () => string
type RouteWithParams<P> = (params: P) => string
type RouteWithOptionalParams<P> = (params?: P) => string

declare module '@faceup/router' {
  export interface RoutesOverride extends RoutesInterface {}
}
